import { render, staticRenderFns } from "./NjButton.vue?vue&type=template&id=33ed8db4&scoped=true"
import script from "./NjButton.vue?vue&type=script&lang=ts"
export * from "./NjButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ed8db4",
  null
  
)

export default component.exports